import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="card shadow-sm border-0">
            <div className="card-body text-center py-5">

              <h1 className="display-1 fw-bold text-primary">404</h1>

              <h3 className="mb-3">Page Not Found</h3>

              <p className="text-muted mb-4">
                The page you are looking for does not exist or has been moved.
              </p>

              <Link to="/" className="btn btn-primary px-4">
                Go to Home
              </Link>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;